export enum PaymentFrequency {
    Unknown = "Unknown",
    Yearly = "Yearly",
    Monthly = "Monthly",
    Fortnightly = "Fortnightly",
    Weekly = "Weekly"
}
